<template>
  <!--
    แพ็กของร้าน — ดูอย่างเดียว (ขาย/ต่ออายุทำฝั่งเรา: bin/license.sh) · ค่ามาจาก license.store ไม่ยิง API เอง
    ว่าง (ไม่มีแพ็ก / อ่าน license ไม่ได้) = ไม่โชว์การ์ด
  -->
  <div v-if="license.planName" class="card mx-3 mt-3">
    <div class="card-body d-flex flex-wrap justify-content-between align-items-center gap-3 py-3">
      <div style="min-width: 0;">
        <div class="fw-semibold">
          <i class="fa-solid fa-crown me-2 text-primary" />
          {{ $t('_plan.Shop plan') }}
          <span class="plan-card__name ms-1">{{ planLabel(license.planName) }}</span>
        </div>
        <div class="text-muted" style="font-size: 13px;">
          <span :class="dateClass">{{ dateText }}</span>
          <span> · {{ branchText }}</span>
        </div>
      </div>

      <div class="d-flex flex-wrap gap-2">
        <a :href="lineHref" target="_blank" rel="noopener" class="btn btn-sm plan-card__line">
          <i class="fa-brands fa-line me-1" />{{ $t('_license.Renew via LINE') }}
        </a>
        <a :href="plansUrl" target="_blank" rel="noopener" class="btn btn-sm btn-outline-secondary">
          <i class="fa-solid fa-tags me-1" />{{ $t('_license.See plans and prices') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { useLicenseStore, SUPPORT_CONTACT, lineRenewUrl } from '@/stores/license.store';
import { planLabel, formatLicenseDate } from '@/utils/licenseDisplay';

export default {
  name: 'PlanSettingsCard',
  computed: {
    license() {
      return useLicenseStore();
    },
    plansUrl() {
      return SUPPORT_CONTACT.plansUrl;
    },
    lineHref() {
      return lineRenewUrl(this.$brand.name || this.$brand.name_en);
    },
    // หมดแล้ว (ผ่อนผัน) = "หมดอายุเมื่อ" · ยังไม่หมด = "ใช้ได้ถึงวันที่"
    dateText() {
      const date = formatLicenseDate(this.license.expiresOn);
      if (!date) return '';
      return this.license.isExpired || this.license.isLocked
        ? this.$t('_license.Expired on') + ' ' + date
        : this.$t('_license.Valid until {date}', { date });
    },
    dateClass() {
      if (this.license.isExpired || this.license.isLocked) return 'text-danger fw-semibold';
      if (this.license.isExpiring) return 'text-warning-emphasis fw-semibold';
      return '';
    },
    // เพดานสาขาจริง (รวมสาขาเพิ่มแล้ว) · null = ไม่จำกัด
    branchText() {
      const limit = this.license.limitOf('limit_branches');
      return limit === null
        ? this.$t('_plan.Unlimited branches')
        : this.$t('_plan.Up to {n} branches', { n: limit });
    }
  },
  methods: {
    planLabel
  }
};
</script>

<style scoped>
.plan-card__name {
  display: inline-block;
  padding: 0.1rem 0.6rem;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 0.8125rem;
  font-weight: 700;
}

.plan-card__line {
  background: #06c755;
  border-color: #06c755;
  color: #fff;
}

.plan-card__line:hover {
  background: #05b04b;
  border-color: #05b04b;
  color: #fff;
}
</style>
